"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ErrorLogAccessLevel_1 = require("../ErrorLogAccessLevel");
var ErrorLogLevel_1 = require("../ErrorLogLevel");
var ErrorLogSignInInfo_1 = require("../ErrorLogSignInInfo");
var ErrorLogType_1 = require("../ErrorLogType");
var zod_1 = require("zod");
var ErrorLogBase_1 = __importDefault(require("./ErrorLogBase"));
var MoreThanOneContactErrorLog;
(function (MoreThanOneContactErrorLog) {
    MoreThanOneContactErrorLog.AdditionalInformationSchema = zod_1.z.object({
        email: zod_1.z.string(),
        contacts: zod_1.z
            .object({
            id: zod_1.z.string(),
            name: zod_1.z.string(),
        })
            .array(),
    });
    MoreThanOneContactErrorLog.Schema = ErrorLogBase_1.default.Schema.extend({
        type: zod_1.z.literal(ErrorLogType_1.ErrorLogType.Enum.moreThanOneContactLinkedToEmail),
        level: zod_1.z.literal(ErrorLogLevel_1.ErrorLogLevel.Enum.ERROR),
        signInInfo: ErrorLogSignInInfo_1.ErrorLogSignInInfo.NotSignedInSchema,
        additionalInformation: MoreThanOneContactErrorLog.AdditionalInformationSchema,
        accessLevel: zod_1.z.literal(ErrorLogAccessLevel_1.ErrorLogAccessLevel.Enum.NONE),
    });
})(MoreThanOneContactErrorLog || (MoreThanOneContactErrorLog = {}));
exports.default = MoreThanOneContactErrorLog;
